import React from 'react';
import { LockOpen, LockOutlined, AccessTime, Devices, Warning } from '@material-ui/icons';
import { ActionTypes, ICreateAction } from '@app/models';

export const createActionTypes = (): ICreateAction[] => {
    let types: ICreateAction[] = [];

    types.push({
        label: 'AUTH_POLICY_ACTION_ALLOWED_METHODS',
        value: ActionTypes.allowedMethods,
        icon: <LockOpen />
    });

    types.push({
        label: 'AUTH_POLICY_ACTION_MFA',
        value: ActionTypes.requiredMethods,
        icon: <LockOutlined />
    });

    types.push({
        label: 'AUTH_POLICY_ACTION_SESSION',
        value: ActionTypes.sessionLifetime,
        icon: <AccessTime />
    });

    types.push({
        label: 'AUTH_POLICY_TRUST_DEVICE',
        value: ActionTypes.trustedDevice,
        icon: <Devices />
    });

    types.push({
        label: 'AUTH_POLICY_ACTION_DENY',
        value: ActionTypes.denyAccess,
        icon: <Warning />
    });

    return types;
};
